import React from 'react'
import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
function RedirectToDetail({ params }) {
  const navigate = useNavigate();
  return (
    <Typography
      variant="body2"
      className="cursor-pointer underline"
      onClick={() => navigate(`/hpd/violations/${params.row.ticket_id}`)}
    >
      {params.value}
    </Typography>
  );
}

export default RedirectToDetail